import axios from '../../axios'

export default {
  getRailObject: function (id) {
    return axios.get('complexdata/railobject/' + id)
  },
  updateRailObject: function (id, alertValueLow, alertValueHigh, warningValueLow, warningValueHigh) {
    return axios.put('complexdata/railobject/update/' + id, {
      AlertValueLow: alertValueLow,
      AlertValueHigh: alertValueHigh,
      WarningValueLow: warningValueLow,
      WarningValueHigh: warningValueHigh
    })
  },
  getComplexMeasurementData: function (id, dtFrom, dtTo) {
    return axios.get('complexdata/measurements/analysis/childMeasurements/' + id, {
      params: {
        dtFrom: dtFrom,
        dtTo: dtTo
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/api/ComplexDataApi.js